const TextInput = ({ type = 'text', variant, onchange, value, placeholder, readonly = false, Before, After }) => {
  const className = 'txtinput ' + (variant ?? '');
  return (
    <div className="txtwrapper">
      {Before && <Before className="before" />}
      { readonly ? 
      <div className={className}>{ value }</div> :
      <input
        type={type}
        onChange={onchange}
        value={value}
        className={className}
        placeholder={placeholder}
        readOnly={readonly}
      /> }
      {After && <After className="after" />}
    </div>
  )
}

export default TextInput;